import React  from 'react';
import { FormHelperText } from '@mui/material'

const HelperTextInput = ({ messages = [] }) => {
    return (
        <FormHelperText 
            style={{ marginRight: '14px', marginLeft: '14px' }} 
            className='MuiFormHelperText-root Mui-error'
        >
            {messages.join("\n")}
        </FormHelperText>
    )
}

export default HelperTextInput;